let loadedDataSets = {};
const purgeLoadedDataSets = () => {
    loadedDataSets = {};
};
export { loadedDataSets, purgeLoadedDataSets };
